var render = function render(){var _vm=this,_c=_vm._self._c;return _c('compliance-password',{key:_vm.key,attrs:{"disabled":_vm.disabled,"label":_vm.$t('local.label'),"required":!!_vm.password,"rules":_vm.localRules,"rulesDependOn":_vm.password,"value":_vm.value,"autocomplete":"new-password","counter":""},on:{"input":_vm.emitInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }